var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import { NavArrow, NavLanguage, NavLanguageItem, NavLanguageItemLink, NavLanguageList, NavLanguageModal, NavLink } from "./styles";
import { Triangle, TriangleShadow } from "../../styles";
import setSession from "../../../../services/session";
class Language extends React.Component {
    constructor(props) {
        super(props);
        this.onChangeUserLanguage = (newLanInfo) => __awaiter(this, void 0, void 0, function* () {
            yield setSession({
                language: newLanInfo.language_code
            });
            if (this.props.onChangeLanguage) {
                this.props.onChangeLanguage(newLanInfo.language_code);
            }
            else {
                location.reload();
            }
        });
        this.state = {
            newUserLanguage: props.userLanguage
        };
    }
    componentDidUpdate(prevProps) {
        const { userLanguage } = this.props;
        if (prevProps.userLanguage !== userLanguage) {
            this.setState({
                newUserLanguage: userLanguage
            });
        }
    }
    render() {
        const { languages, userLanguage } = this.props;
        return (React.createElement(NavLanguage, null,
            React.createElement(NavLink, null, userLanguage === null || userLanguage === void 0 ? void 0 : userLanguage.language_text),
            React.createElement(NavLanguageModal, null,
                React.createElement(Triangle, { style: { left: "70%" } }),
                React.createElement(TriangleShadow, { style: { left: "70%" } }),
                React.createElement(NavLanguageList, null, languages && languages.map((item, index) => (React.createElement(NavLanguageItem, { key: index, onClick: () => this.onChangeUserLanguage(item) },
                    React.createElement(NavLanguageItemLink, { active: (userLanguage === null || userLanguage === void 0 ? void 0 : userLanguage.language_code) === item.language_code }, item === null || item === void 0 ? void 0 : item.language_text)))))),
            React.createElement(NavArrow, null)));
    }
}
export default Language;
